const locale = require('./dragAndDropDebugger.i18n.json');

/*@ngInject*/
const DragAndDropDebuggerController = function ($scope, $element, formViewerConstant, $timeout) {

    this.$onInit = () => {
        $element.addClass('dragAndDropDebugger');
        this.locale = locale;
    };

    this.renderDebuggerInfo = (debuggerInfo) => {
        this.debuggerInfo = debuggerInfo;

        if (debuggerInfo.isTopDropAttempt) {
            this.dropTypeValue = 'Top';
        }
        else if (debuggerInfo.isBottomDropAttempt) {
            this.dropTypeValue = 'Bottom';
        }
        else if (debuggerInfo.isLeftDropAttempt) {
            this.dropTypeValue = 'Left';
        }
        else if (debuggerInfo.isRightDropAttempt) {
            this.dropTypeValue = 'Right';
        }
    };

    $scope.$on(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT, function(event, debuggerInfo) {
        this.renderDebuggerInfo(debuggerInfo);
    }.bind(this));
};

angular.module('umFormViewer')
    .controller('dragAndDropDebuggerController', DragAndDropDebuggerController);
